import * as styles from './styles';
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { FC, useMemo } from 'react';
import { ReactComponent as FocusedCheck } from '@assets/icons/focused_check.svg';
import { ReactComponent as Check } from '@assets/icons/check.svg';
import { useAgreementContext } from '@context/Agreement';

interface IconButton {
  focusKey: string;
  index: 0 | 1 | 2 | 3;
}

const SpecificAgreementButton: FC<IconButton> = (props) => {
  const { focusKey, index } = props;
  const {
    agreements,
    setSpecificAgreement,
    isAgreedSpecificAgreement,
    changeSpecificAgreementState
  } = useAgreementContext();
  const isAgreed = isAgreedSpecificAgreement[index];

  const { ref, focused } = useFocusable({
    onFocus: () => setSpecificAgreement(index),
    onEnterPress: async () => await changeSpecificAgreementState(index),
    focusKey
  });

  const Icon = useMemo(() => {
    if (focused || isAgreed) {
      return <FocusedCheck />;
    }
    return <Check />;
  }, [isAgreed, focused]);

  return (
    <div css={[styles.buttonStyle, focused && styles.focusedStyle]} ref={ref}>
      <p css={styles.buttonText}>{agreements[index].title}</p>
      {Icon}
    </div>
  );
};
export default SpecificAgreementButton;
